<template>
    <b-form>
        <b-row class="m-2">
            <b-col v-if="loaded === false">
                <template>
                    <div class="OTloading">
                        <div class="OTloader"></div>
                    </div>
                </template>
            </b-col>
            <b-col v-else>
                <b-row>
                    <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>          
                    <ECMPartitionModal v-model="showECMPartitionModal" :existingNames="paramSets" ref="ecmPartitionModal" /> 
                    <RDBMSRenamePartitionModal v-model="showRDBMSRenamePartitionModal" :existingNames="paramSets" ref="rdbmsPartitionModal" />  
                    <ECMConfirmDialog ref="confirmationDlg" v-model="confirmationDlg"/>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="row no-gutters">
            <span class="OTtableTitleBreadCrumb">
                <span class="OTtableTitleBreadCrumbTextJob"></span>
            </span>
        </b-row>
        <b-row class="row no-gutters">
            <b-col class="col-auto col">
                <b-nav>
                    <b-nav-item v-for="action in globalActions" @click.prevent="onGlobalAction(action)" :key="action.name">
                        <otif-icon :icon="action.name" :label="action.label" :title="action.label" key="action.name"/>
                    </b-nav-item>
                </b-nav>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="paramSets.length === 0">
                <span class="OTtableJobType"><p> {{ecmResourceStrings.txtPartitionsNotDefined}}</p>
                    <otif-icon icon="information"/>
                </span >
            </b-col>
            <b-col v-else>
                <ecmconnection-select
                    v-model="$v.selectedSet"
                    v-bind:label="ecmResourceStrings.lblPartitionName"
                    :parameters="paramSets"
                    :selectedSet="selectedSet"
                    ref="params_selector"
                    :description="ecmResourceStrings.tipECMPartitions"
                    v-bind:invalidMessage="ecmResourceStrings.msgECMPartitionRequired"
                    @reselected="reselected"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <template v-if="loaded === false">
                    <div class="OTloading">
                        <div class="OTloader"></div>
                    </div>
                </template>
                <template v-else-if="loaded === true && paramSets.length === 0">
                   
                </template>
              
               
            </b-col>
        </b-row>
        
        <template v-if="loaded === true && paramSets.length > 0">
             <otif-textInput
                v-bind:label="ecmResourceStrings.lblViewName"
                v-model="sqlViewName"
                :required="true"
                invalidMessage="Deployment name is required"
                />
            <otif-textarea
                v-model="sqlWhere"
                v-bind:label="ecmResourceStrings.lblSqlWhere" />
            <otif-textarea
                v-model="sqlOrderBy"
                v-bind:label="ecmResourceStrings.lblSqlOrderBy" />
         </template>
    </b-form>
</template>

<script>

import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { numericval } from '../../../utils/validatorECM.js';
import { showMessage } from '../../../utils/commonECM.js';
import OtifGlobalActions from '../../../../../../mtm-studio-components/src/components/table/GlobalActions.vue';
import SettingsTable from '@/ecm/components/ECMParametersTable.vue';
import EcmRepositoryConnections from '../../../../ecm/components/widgets/ECMRepositoryConnections.vue';
import ECMPartitionModal from '../../modals/ECMCreatePartition.vue';
import RDBMSRenamePartitionModal from '../../modals/RDBMSRenamePartition.vue';
import ECMConfirmDialog from '../../modals/ECMCrawlerConfirmDlg.vue';
import { showConfirmationDialog } from '../../../utils/commonECM.js';
import StatusColumn from '../../links/ecmmandatorystatus.vue';
import { getguivalue } from '../../../utils/commonECM.js';

export default {

    props: ['realPartitionsConfigurations' , 'availablePartitionsConfigurations'],
    
    components: {
        ECMErrorDialog,
        OtifGlobalActions,
        SettingsTable,
        ECMPartitionModal,
        RDBMSRenamePartitionModal,
        'ecmconnection-select': EcmRepositoryConnections,
        ECMConfirmDialog,
    },
    mixins: [ validationMixin ],

    data() {
        return { 
            paramSets : [],
            selectedSet:'0',
            
            sqlWhere:'',
                     
            sqlOrderBy:'',
            sqlViewName:'',
            
            fullPackage : [],
                        
            lastexistingindex:-1,
            selectionchanged:false,
            loaded: false,
            messageDlg: false,
            confirmationDlg:false,
            showECMPartitionModal: false,
            showRDBMSRenamePartitionModal: false,
            
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            globalActions: [{
                    name: 'add',
                    label: 'Add Partition',
                    callback: () => { this.addPartition(); }
                },
                {
                    name: 'delete',
                    label: 'Delete Partition',
                    callback: () => { this.deletePartition(); }
                },
                {
                    name: 'edit',
                    label: 'Edit Partition Name',
                    callback: () => { this.renamePartition(); }
                }
            ],
        }
    },

    validations: {
        form: {
          
        }
    },

       
    computed: {
    },

    watch: {
        sqlViewName(newval){
            this.updateelement('sqlViewName',newval);
        },
        sqlWhere(newval){
            this.updateelement('sqlWhere',newval);
        },
        sqlOrderBy(newval){
            this.updateelement('sqlOrderBy',newval);
        },
    },

    methods: {
        
        onGlobalAction(action) {
            if (action['callback']) {
                action.callback(action);
            }
        },

        updateelement(name, value)
        {
            var that = this;
           
            if(that.selectionchanged == false)
            {
                if(this.selectedParameters)
                {
                    var cnt = 0;
                    for (cnt = 0; cnt < this.selectedParameters.length; cnt++)
                    {
                        if(this.selectedParameters[cnt].name == name)
                        {
                            this.selectedParameters[cnt].value = value; 
                            break;
                        }
                    }
                    for (cnt = 0; cnt < this.realPartitionsConfigurations.length; cnt++)
                    {
                        if(this.realPartitionsConfigurations[cnt].name == name && this.realPartitionsConfigurations[cnt].index == this.selectedSet)
                        {
                            this.realPartitionsConfigurations[cnt].value = value; 
                            break;
                        }
                    }
                }
            }
            else
            {
                that.selectionchanged = false;
            }
        },

        reselected(value) {
           var that = this;
           that.selectionchanged = true;
           that.selectedSet=value;
           var cnt = 0;
           for (cnt = 0; cnt < that.paramSets.length; cnt++)
            {
                if(that.paramSets[cnt].index == value)
                {
                     that.selectedParameters = that.paramSets[cnt].setOfParameters;
                    if(that.selectedParameters)
                    {
                        that.sqlWhere=  that.getselectedvalue('sqlWhere');
                        that.sqlOrderBy=  that.getselectedvalue('sqlOrderBy');
                        that.sqlViewName=  that.getselectedvalue('sqlViewName');
                    }
                    return;
                }
            }
        },
        getselectedvalue(name)
        {
            var that = this;
            if(that.selectedParameters)
            {
                var i = 0;
                for(i=0;i<that.selectedParameters.length; i++)
                {
                    if(name == that.selectedParameters[i].name)
                    {
                        return that.selectedParameters[i].value;
                    }
                }
            }
            return '';
        },

       /* save(element) {
            //prevent old name just in case if for mandatory field value is empty 
            var that = this;
            var originalvalue='';
            const result = this.realPartitionsConfigurations.filter((el) => (el.name == element.name && el.index == element.index));
            if (result != undefined && result.length == 0)
            {
                //not found
            }
            else if (result != undefined && result.length == 1)
            {
                originalvalue = result[0].value;
            }

            const value = element.value;
            var configvalue = "";
            if(value.trim().length > 0)
            {
                configvalue = JSON.stringify(value); 
                //configvalue = configvalue.replace(/"/g, ""); 
                configvalue = configvalue.replace(/"/ , ""); 
                configvalue = configvalue.replace(/"$/,"");
            }
            else if(element.mandatory == 1)
            {
                //can not be empty
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtErrorMandatory);
                element.value = originalvalue;
                return;
            }
            if (result[0])
            {
                //should be here
                result[0].value = element.value;
                //change description of package in set
                if(element.name == 'description')
                {
                    var cnt = 0;
                    for (cnt = 0; cnt < that.paramSets.length; cnt++)
                    {
                        if(that.paramSets[cnt].description == originalvalue)
                        {
                            that.paramSets[cnt].description = element.value; 
                            that.selectedName=that.paramSets[cnt].description;  
                            that.partitionName = that.paramSets[cnt].description;
                       
                            if(that.$refs.params_selector)
                                that.$refs.params_selector.refresh();
                            break;
                        }
                    }
                }
            }
        },*/


        addPartition(){
            this.showECMPartitionModal = true;
        },

        renamePartition(){
            this.showRDBMSRenamePartitionModal=true;
        },

        createEcmPartition(conDescr){
            var that = this;
                        
            const len = that.paramSets.length;
            
            that.lastexistingindex++;
            
            var OneSet = [];
                        
            for (var cnt = 0; cnt < that.fullPackage.length; cnt++)
            {
                const name  = that.fullPackage[cnt].name;
                
                if(name == 'description')
                {
                    that.realPartitionsConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": conDescr, "index": that.lastexistingindex});
                    OneSet.unshift({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : 1, "value": conDescr, "index": that.lastexistingindex });
                }
                else
                {
                    that.realPartitionsConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "index": that.lastexistingindex});
                    OneSet.push({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "index": that.lastexistingindex });
                }
            }
            
            that.paramSets.push({"description": conDescr, "index":that.lastexistingindex, "setOfParameters":OneSet});
            
            if(that.paramSets.length > 0)
            {
                that.selectedSet=that.lastexistingindex;
                var cnt = 0;
                for (cnt = 0; cnt < that.paramSets.length; cnt++)
                {
                    if(that.paramSets[cnt].index == that.lastexistingindex)
                    {
                        that.selectedParameters = that.paramSets[cnt].setOfParameters;
                         if(that.selectedParameters)
                        {
                            that.sqlWhere=  that.getselectedvalue('sqlWhere');
                            that.sqlOrderBy=  that.getselectedvalue('sqlOrderBy');
                            that.sqlViewName=  that.getselectedvalue('sqlViewName');
                        }
                        break;
                    }
                }
                if(that.$refs.params_selector)
                {
                    that.$refs.params_selector.selectedSet = that.selectedSet;
                    that.$refs.params_selector.refresh();
                }
            }
        },

        renameRDBMSPartitionF(newName){
            var that = this;
            if(this.selectedParameters)
                {
                    var cnt = 0;
                    for (cnt = 0; cnt < this.selectedParameters.length; cnt++)
                    {
                        if(this.selectedParameters[cnt].name == 'description')
                        {
                            this.selectedParameters[cnt].value = newName; 
                            break;
                        }
                    }
                    for (cnt = 0; cnt < this.realPartitionsConfigurations.length; cnt++)
                    {
                        if(this.realPartitionsConfigurations[cnt].name == 'description' && this.realPartitionsConfigurations[cnt].index == this.selectedSet)
                        {
                            this.realPartitionsConfigurations[cnt].value = newName; 
                            break;
                        }
                    }
                    
                    that.paramSets[that.selectedSet].description =newName;
                    if(that.$refs.params_selector)
                        that.$refs.params_selector.refresh();
                }
        },

        deletePartition(){
            var that = this;
            that.bDeletePartition = true;
            showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeletePartition, that.ecmResourceStrings.txtDeletePartition);
        },

        saveConfirmed()
        {         
            this.confirmationDlg = false;
            var that = this;
            if(that.bDeletePartition == true)
            {
                that.bDeletePartition = false;
                const itemX=that.selectedSet;
                var cnt = 0;
                for (cnt = 0; cnt < that.paramSets.length; cnt++)
                {
                    if(that.paramSets[cnt].index == itemX)
                    {
                        const removed = that.paramSets.splice(cnt, 1);
                        break;
                    }
                }

                if(itemX < that.paramSets.length)
                {
                    cnt = itemX;
                    for (cnt = itemX; cnt < that.paramSets.length; cnt++)
                    {
                        const newindex = that.paramSets[cnt].index - 1;
                        that.paramSets[cnt].index =newindex;
                        var dataSet = that.paramSets[cnt].setOfParameters;
                        if(dataSet)
                        {
                            var k = 0;
                            for (k = 0; k < dataSet.length; k++)
                            {
                                dataSet[k].index= newindex;
                            }
                        }
                    }
                }
                if(that.paramSets.length > 0)
                {
                    that.selectedSet=that.paramSets[0].index;
                    that.selectedParameters = that.paramSets[0].setOfParameters;
                  
                    if(that.selectedParameters)
                    {
                        that.sqlWhere=  that.getselectedvalue('sqlWhere');
                        that.sqlOrderBy=  that.getselectedvalue('sqlOrderBy');
                        that.sqlViewName=  that.getselectedvalue('sqlViewName');
                    }
                    if(that.$refs.params_selector)
                        that.$refs.params_selector.refresh();  
                   
                }
                else
                {
                    that.selectedSet=0;
                    that.sqlWhere=  '';
                    that.sqlOrderBy= '';
                    that.sqlViewName=  '';
                    that.selectedParameters=[];
                }
                cnt = 0;   
                for (cnt = that.realPartitionsConfigurations.length -1; cnt > -1; cnt--)
                {
                    const index = that.realPartitionsConfigurations[cnt].index;
                    if(index == itemX)   
                    {
                        const removed = that.realPartitionsConfigurations.splice(cnt, 1);
                    }
                }
                if(itemX < that.paramSets.length)
                {
                    for (cnt = itemX; cnt < that.realPartitionsConfigurations.length; cnt++)
                    {
                        const newindex = that.realPartitionsConfigurations[cnt].index - 1;
                        that.realPartitionsConfigurations[cnt].index = newindex;
                    }
                }

                if(that.$refs.params_selector)
                {
                    that.$refs.params_selector.selectedSet = that.selectedSet;
                    that.$refs.params_selector.refresh();
                }
            }
        },
        
        initParams : function()
        {   
            //  fullParamsPackage
            var that = this;
            that.fullPackage = [];//all mandatory + available together - one whole set (prototype of set) 
            that.paramSets = [];
            
            var cnt = 0; 
            for (cnt = 0; cnt < that.availablePartitionsConfigurations.length; cnt++)
            {
                if(that.availablePartitionsConfigurations[cnt].name != 'status' && that.availablePartitionsConfigurations[cnt].name != 'statusDate')
                {
                    that.fullPackage.push({"name" : that.availablePartitionsConfigurations[cnt].name, "type" : that.availablePartitionsConfigurations[cnt].type, "defaultvalue": that.availablePartitionsConfigurations[cnt].defaultvalue, "mandatory" : 0, "value": that.availablePartitionsConfigurations[cnt].value});
                }
            }
    
            var currentIndex = -1;
            var startindex = -1;
            var lastindex = -1;
            
            
            var descr = ''; var index = -1;
            cnt = 0;
            for (cnt = 0; cnt < that.realPartitionsConfigurations.length; cnt++)
            {
                var OneSet = [];
                const name  = that.realPartitionsConfigurations[cnt].name;
                if(startindex == -1)
                {
                    startindex = 0;
                }
                currentIndex = that.realPartitionsConfigurations[cnt].index;
                if( lastindex < currentIndex)
                    lastindex = currentIndex;
                var bFound = false;
                var currentparamset = undefined;
                if(that.paramSets.length > 0)
                {
                    var i =0;
                    for (i = 0; i < that.paramSets.length; i++)
                    {
                        const testindex = that.paramSets[i].index;
                        if(testindex == currentIndex)
                        {
                            currentparamset=that.paramSets[i];
                            bFound = true;
                            break;
                        }
                    } 
                }

                if(bFound == true && currentparamset)
                {
                    OneSet = currentparamset.setOfParameters;
                }
                
                descr = '';
                if(name == 'description')
                {
                    descr = that.realPartitionsConfigurations[cnt].value;
                    index = that.realPartitionsConfigurations[cnt].index;
                    OneSet.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index});
                }
                else
                {
                    OneSet.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : that.realPartitionsConfigurations[cnt].mandatory, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index});
                }

                if(bFound == false)
                {
                    that.paramSets.push({"description":descr, "index":currentIndex, "setOfParameters":OneSet});
                }
                else
                {
                    if(name == 'description')
                    {
                        if(currentparamset && currentparamset.description == '')
                        {
                            currentparamset.description = descr;
                        } 
                    }
                }
            }
            if(that.paramSets.length > 0)
            {
                that.selectedSet=0;
                
                that.selectedParameters = that.paramSets[0].setOfParameters;
                if(that.selectedParameters)
                {
                    that.sqlWhere=  that.getselectedvalue('sqlWhere');
                    that.sqlOrderBy=  that.getselectedvalue('sqlOrderBy');
                    that.sqlViewName=  that.getselectedvalue('sqlViewName');
                }
            }
            that.lastexistingindex = lastindex;
        },
    },
      
    mounted() {

            var breadcrumbs = [{
                name: 'settings',
                meta: { label: 'Settings' }
            },        {
                name: 'rdbms-repositories',
                meta: { label: 'Repositories' }
            },{
                name: 'rdbms-repo',
                meta: { label: 'Update RDBMS Repository' }
            }];
            this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        that.initParams();
        that.loaded = true;
    },
}
</script>